import React from 'react'
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'


function ReportedPromotions() {
  return (
    <IncludeSideBar>
        <div>
            <p>
                Here we are displaying the Reported Promotions sections.
            </p>
        </div>
    </IncludeSideBar>
  )
}

export default ReportedPromotions